/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { Logger } from 'fsts';
import { namespace } from 'vuex-class';
import { Contact } from '@/shared/model/contact';
import ContactPanels from './contact-panel/contact-panel.vue';
import { OdataItems } from '@/shared/model/OdataItems';
import { GspUserRole, UserActiveServices } from '@/shared/model/gspUserRole';
import { VChip } from 'vuetify/lib';
import ChangeLogInfo from './change-log-info/change-log-info.vue';
import { GspUserRoleDetailInner } from '@/shared/model/gspUserRoleDetail';

import ilpartnerImage from '@/assets/ilpartner.jpg';
import roomioImage from '@/assets/roomio.jpg';
import trendhopperImage from '@/assets/trendhopper.jpg';


const logger = new Logger('contact');
const contactModule = namespace('contact');
const contactPanelModule = namespace('contactPanel');
const gspRoleModule = namespace('gspRole');
const gspUserRoleModule = namespace('gspUserRole');

@Component({
  components: { ContactPanels, VChip, ChangeLogInfo },
})
export default class ContactView extends Vue {
  @contactModule.Action('updateContactRights')
  private actionUpdateContactRights!: any;
  @contactPanelModule.Action('deleteContactPanel')
  private actionDeleteContactPanel!: any;
  @contactModule.Action('countHouseAdminsInZrCluster')
  private actionCountHouseAdminsInZrCluster!: (contact: Contact) => Promise<number>;

  @contactModule.Getter('getContactForLoggedInUser')
  private contactForLoggedInUser!: Contact;

  // @contactModule.Action('countActiveServices')
  // private actionCountActiveServices!: (contactId: number) => Promise<number>;


  @contactPanelModule.Action('updateContactPanel')
  private actionUpdateContactPanel!: any;
  @contactPanelModule.Action('updateContactPanelKatalogwand')
  private actionUpdateContactPanelKatalogwand!: any;

  @gspUserRoleModule.Action('updateGspUserRole')
  private actionUpdateGspUserRole!: any;
  @gspUserRoleModule.Getter('getGspUserRoles')
  private userRoles!: OdataItems<GspUserRole>;


  @gspRoleModule.Getter('getGspRoles')
  private gspRoles!: any;

  // @gspUserRoleModule.Action('getUserActiveServices')
  // private actionUserActiveServices!: any;
  @gspUserRoleModule.Getter('getUserActiveServices')
  private getUserActiveServices!: UserActiveServices[];

  //#region (AD-313) Brand License Logic
  @contactModule.Getter('hasRoomioInMarkenportfolio')
  private hasRoomioInMarkenportfolio!: (zrNumbers: any) => boolean;
  @contactModule.Getter('hasTrendhopperInMarkenportfolio')
  private hasTrendhopperInMarkenportfolio!: (zrNumbers: any) => boolean;
  @contactModule.Getter('hasInterlivingInMarkenportfolio')
  private hasInterlivingInMarkenportfolio!: (zrNumbers: any) => boolean;

  get brandLicenseImages(): {
    name: string;
    label: string;
    image: string;
  }[] {
    const images: {
      name: string;
      label: string;
      image: string;
    }[] = [];

    if (this.showInterlivingPartner) {
      images.push({
        name: 'interliving',
        label: this.$t('interliving_partner') as string,
        image: ilpartnerImage,
      });
    }

    if (this.showTrendhopperLizenz) {
      images.push({
        name: 'trendhopper',
        label: this.$t('trendhopper_lizenz') as string,
        image: trendhopperImage,
      });
    }

    if (this.showRoomioLizenz) {
      images.push({
        name: 'roomio',
        label: this.$t('roomio_lizenz') as string,
        image: roomioImage,
      });
    }

    return images;
  }


  get showRoomioLizenz(): boolean {
    return this.hasRoomioInMarkenportfolio(this.contact.companyZrNumber);   // raw comma-separated string works
  }
  get showTrendhopperLizenz(): boolean {
    return this.hasTrendhopperInMarkenportfolio(this.contact.companyZrNumber);
  }
  get showInterlivingPartner(): boolean {
    return this.hasInterlivingInMarkenportfolio(this.contact.companyZrNumber);
  }

  get brandLicenseLabels(): string[] {
    const labels: string[] = [];
    if (this.showRoomioLizenz) labels.push(`${this.$t('roomio_lizenz')}`);
    if (this.showTrendhopperLizenz) labels.push(`${this.$t('trendhopper_lizenz')}`);
    if (this.showInterlivingPartner) labels.push(`${this.$t('interliving_partner')}`);
    return labels;
  }
  //#endregion



  @Prop()
  private contact!: Contact;

  private readonly maxHouseAdminsPerZrCluster = 3;
  private zrbi = false;
  isUpdatingHouseAdmin = false;
  localIsHouseAdmin = false;

  // init `localIsHouseAdmin`
  @Watch('contact.isHouseAdmin', { immediate: true })
  onIsHouseAdminChanged(newValue: boolean) {
    // console.log('zzz  onIsHouseAdminChanged watcher:>> ', newValue );
    this.localIsHouseAdmin = newValue;
  }

  // (AD-268) customer requeste to delete `istILDashboardFreigabeberechtigtePersonMeinVMEGenehmigungen` field from `Contact` model
  // get loggedInUserContactVme() {
  //   return this.contactForLoggedInUser?.istILDashboardFreigabeberechtigtePersonMeinVMEGenehmigungen;
  // }

  mounted() {
    // const result = this.userRoles.items.find((role:any) => role.contactEmail == this.contact.email);
    // console.log('mounted userRole result :>> ', result);
    // console.log('mounted  contact:>> ', this.contact.email);
    if (this.userRole?.zrNumRolesData) {
      this.userRoleData = JSON.parse(this.userRole?.zrNumRolesData);

      this.userRoleData.forEach((element: any, index) => {
        if (element?.zrNummer) {
          Vue.set(this.boxes, index, true);
          Vue.set(this.roleBoxes, index, element.roles);
        }
      });
      this.userRolesPayload = this.userRoleData;
    }
  }

  //#region
  isSaving = false;
  userRolesPayload: any = [];

  boxes: Array<boolean> = [false];
  roleBoxes: Array<any> = [];
  userRoleData = [];

  get zrNumberArr() {
    return this.contact.companyZrNumber?.split(',') || [];
  }

  get isSupplierUrl() {
    return this.$route.fullPath.includes('/supplier');
  }

  get userRole() {
    // (AD-143) possible `email` duplicates (1 active and 1 inactive `Contacts` with the same `email`), so decided to use both `recordID` + `email`
    let result = this.userRoles.items.find((role: any) => role.contactId == this.contact.recordID); // (AD-174) now filter `GspRole` ONLY by ContactId (`RecordID`)
    // if (!result) {
    //   result = this.userRoles.items.find((role: any) => role.contactEmail.toLowerCase() == this.contact.email.toLowerCase()); 
    // }
    return result;
  }

  get roles() {
    return this.gspRoles.items;
  }
  not(e: any) {
    e.preventDefault();
    e.stopPropagation();

    console.log('e :>> ', e);
  }

  changeZrNumbBox(ev: any, item: any, i: any) {
    console.log('ev :>> ', ev);
    console.log('item :>> ', item);
    console.log('i :>> ', i);
    console.log('this.gspRoles :>> ', this.gspRoles);
    if (!ev) {
      this.removeZrNumRole('zrNum', i);
    }
  }

  removeZrNumRole(source: any, index: number) {
    this.userRolesPayload[index] = null;
    if (source == 'zrNum') {
      Vue.set(this.roleBoxes, index, null);
    }
  }

  changeRole(ev: any, item: any, i: any) {
    if (ev.length == 0) {
      this.removeZrNumRole('role', i);
    }
    console.log('ev :>> ', ev);
    console.log('item :>> ', item);
    console.log('i zr :>> ', i);

    let obj = { zrNummer: item.trim(), roles: ev };
    this.userRolesPayload[i] = obj;
    // this.boxes[i] = ev.length>0 ;
    Vue.set(this.boxes, i, ev.length > 0);

    // Array.prototype.splice
    // vm.items.splice(indexOfItem, 1, newValue)
  }

  save() {
    console.log('save roles:>> ');

    const payload = {
      id: this.userRole?.id || undefined,
      contactId: this.contact.recordID,
      contactEmail: this.contact.email,
      zrNumRolesData: JSON.stringify(this.userRolesPayload),
    };
    console.log('payload :>> ', payload);
    this.actionUpdateGspUserRole(payload);
  }
  //#endregion

  //#region (AD-67) Condition for `IL-KPI` checkbox
  private multipleValuesToken = [',', ';'];

  private isSingleIlDashboardAzureServiceID =
    !!this.contact.ilDashboardAzureServiceID &&
    this.multipleValuesToken.every((token) => !this.contact.ilDashboardAzureServiceID.includes(token));

  get isCompanyInAzureService(): boolean {
    let condition = false;
    if (this.isSingleIlDashboardAzureServiceID) {
      condition = this.contact.azureServices.includes(this.contact.ilDashboardAzureServiceID);
    } else {
      const dashboardAzureServices = this.contact.ilDashboardAzureServiceID.split(/[;,]+/); // use multiple separators, just in case

      condition = dashboardAzureServices.some((companyAzureServiceId) =>
        this.contact.azureServices.includes(companyAzureServiceId.trim())
      );
    }

    return !!this.contact.ilDashboardAzureServiceID && condition;
  }
  //#endregion

  get isKatalogwand() {
    return this.contact?.azureServices?.includes('9360b61c-1af1-487a-970f-3872b2b3265c');
  }

  get isLoggedInUserEmail(): boolean {
    return this.contact.email === this.contactForLoggedInUser?.email;
  }

  // (2024-04) THIS logic outdated by customer word
  // get rightsCount(): number {
  //   const sum = this.isCompanyInAzureService ? 1 : 0;
  //   const sum2 = this.contact.isZrBiActive ? 1 : 0;
  //   const sum3 = this.isKatalogwand ? 1 : 0;

  //   return sum + sum2 + sum3;
  // }

  get rightsCount(): number {
    let gspUserRoleDetailsCount = this.userRole?.gspUserRoleDetails?.length || 0;
    if (gspUserRoleDetailsCount) {
      //console.log('this.userRole?.gspUserRoleDetails :>> ', this.userRole?.gspUserRoleDetails);
      gspUserRoleDetailsCount =
        this.userRole?.gspUserRoleDetails?.filter(
          (x) =>
            typeof x.roleDetails == 'object' &&
            (x.roleDetails as GspUserRoleDetailInner[]).find((y) => y.moduleRoles?.find((z) => z.roles?.length))
        ).length ?? 0;
    }
    return gspUserRoleDetailsCount;
  }

  CountServeces(contactId: any): any {
    //let rightCount = this.actionCountActiveServices(contactId);
    let result: any = 0;
    result = this.getUserActiveServices.find((x: any) => x.contactID == contactId)?.countRight;
    if (result == undefined) {
      result = 0;
    }
    return result;
  }

  changeActiveSwitch(): void {
    if (this.isLoggedInUserEmail) {
      return;
    }
    this.$emit('update:active', this.contact);
  }

  async changeHouseAdminSwitch(newValue: boolean): Promise<void> {
    if (this.isLoggedInUserEmail || this.isUpdatingHouseAdmin) {
      this.localIsHouseAdmin = !newValue;  // Revert immediately if blocked
      return;
    }
    // console.log('z newValue :>> ', newValue);

    const previousValue = this.contact.isHouseAdmin;  // Store original value

    this.isUpdatingHouseAdmin = true;
    // If the switch has been set to true, check if the new amount does not surpass
    // the allowed amount of house admins in the zr cluster of this contact.
    // if (this.contact.isHouseAdmin) {
    if (newValue) {
      let currentAmount = await this.actionCountHouseAdminsInZrCluster(this.contact);
      if (currentAmount >= this.maxHouseAdminsPerZrCluster) {
        this.localIsHouseAdmin = false; // Revert switch visually
        this.isUpdatingHouseAdmin = false;
        this.$message.open(
          this.$tc('max_house_admin_count_reached_title'),
          this.$tc('max_house_admin_count_reached_text'),
          { hasCancelBtn: false, okText: this.$t('max_house_admin_count_reached_ok') }
        );
        return;
      }
    }

    // Emit to parent with callbacks
    this.$emit('update:is-house-admin', {
      contact: this.contact,
      newValue,
      previousValue,
      onSuccess: (finalValue: boolean) => {
        // console.log('onSuccess  call:>> ', finalValue);
        this.isUpdatingHouseAdmin = false;
        this.localIsHouseAdmin = finalValue;
      },
      onError: (revertValue: boolean) => {
        // console.log('onError  call:>> ',revertValue );
        this.isUpdatingHouseAdmin = false;
        this.localIsHouseAdmin = revertValue;
      }
    });
  }

  changeZrBiCheckbox(event: any): void {
    //const box = this.$el.querySelector<any>('.zr-bi__checkbox [type="checkbox"]');
    // console.log('box :>> ', box?.checked); // get real checkbox input value
    //const checkboxValue = box?.checked;

    const checkboxValueBeforeClick = this.contact.isZrBiActive;

    // show dialog on label click if checkbox checked(TRUE) otherwise ignore
    if (event.target.className.includes('zr-bi__label')) {
      // if label clicked finish this method and let the `zrBiLabelClick` method handle label click event
      return;
    }

    if (!checkboxValueBeforeClick) {
      this.showDocDialog();
    } else {
      event.preventDefault();
      event.stopPropagation();

      this.showDeleteConfirmation();
    }
  }

  zrBiLabelClick(event: any): void {
    logger.log('zrBiLabelClick event :>> ', event);
    // console.log('this.contact.isZrBiActive :>> ', this.contact.isZrBiActive);
    if (this.contact.isZrBiActive) {
      this.showDocDialog();
    }
    event.preventDefault();
  }

  showDeleteConfirmation(): void {
    // (AD-67) should not delete `ContactPanel` but clear `ZR-BI` fields
    this.$confirm
      .open(`${this.$t('zrbi_dialog_title')}`, `${this.$t('zrbi_dialog_text')}`, {
        cancelText: this.$t('zrbi_dialog_cancel'),
        okText: this.$t('zrbi_dialog_ok'),
      })
      .then(async (response: any) => {
        logger.log('before IF response askDialog :>> ', response);
        if (response) {
          logger.log('contactPanelId :>> ', this.contact.contactPanelId);
          if (this.contact.contactPanelId) {
            const contactPanelPayload = {
              id: this.contact.contactPanelId,
              email: this.contact.email,
              isKpiChangeMode: false, // send from dialog related to `ZR-BI`
            };

            this.actionUpdateContactPanel(contactPanelPayload)
              .then((result: any) => {
                this.contact.isZrBiActive = result.isZrBiActive;
                logger.log('actionUpdateContactPanel ZR-BI result :>> ', result);
              })
              .catch((err: any) => {
                logger.error(err);
              });
          }
        } else {
          this.contact.isZrBiActive = true;
        }
      });
  }

  showDocDialog(): void {
    logger.log('showDocDialog :>> ');
    this.$emit('show:dialog', this.contact);
  }

  changeKatalogwand(wandValue: boolean): void {
    const azureServicesChecked = wandValue
      ? `${this.contact.azureServices ? this.contact.azureServices + ';' : ''}9360b61c-1af1-487a-970f-3872b2b3265c`
      : this.contact.azureServices.replace('9360b61c-1af1-487a-970f-3872b2b3265c', ';').replace(';;', '');

    const payload = {
      RecordID: this.contact.recordID,
      azureServices: azureServicesChecked,
    };

    this.actionUpdateContactRights(payload)
      .then((result: any) => {
        logger.log('actionUpdateContactRights result :>>', result);
        this.contact.azureServices = azureServicesChecked;

        const contactPanelPayload = {
          id: this.contact.contactPanelId,
          email: this.contact.email,
          isKpiChangeMode: false,
          katalogwand: wandValue,
        };

        this.actionUpdateContactPanelKatalogwand(contactPanelPayload).then((result: any) => {
          this.contact.contactPanelId = result.id;
          logger.log('actionUpdateContactPanel Katalogwand result :>> ', result);
        });
      })
      .catch((err: any) => {
        logger.error(err);
      });
  }

  changeKpi(kpiValue: boolean): void {
    const azureServicesChecked = this.getCorrectAzureServices(kpiValue);

    const payload = {
      RecordID: this.contact.recordID,
      isKpi: kpiValue,
      azureServices: azureServicesChecked,
    };

    this.actionUpdateContactRights(payload)
      .then((result: any) => {
        logger.log('actionUpdateContactRights result :>>', result);
        this.contact.azureServices = azureServicesChecked;

        const contactPanelPayload = {
          id: this.contact.contactPanelId,
          email: this.contact.email,
          isIlKpiActive: kpiValue,
          isKpiChangeMode: true,
        };

        this.actionUpdateContactPanel(contactPanelPayload).then((result: any) => {
          this.contact.contactPanelId = result.id;
          logger.log('actionUpdateContactPanel IL-KPI result :>> ', result);
        });
      })
      .catch((err: any) => {
        logger.error(err);
      });
  }

  getCorrectAzureServices(ilKpiValue: boolean): string {
    const originalAzureServices = this.contact.azureServices;
    let ilDashboardAzureServiceID = this.contact.ilDashboardAzureServiceID;
    const isMultipleCompanyAzureServiceID = this.multipleValuesToken.some((token) =>
      ilDashboardAzureServiceID.includes(token)
    );
    const contactHasAzureServices = !!originalAzureServices.trim();
    let result = '';

    // if `ilDashboardAzureServiceID` is null or empty do nothing (just use old original Contact `azureServices`)
    if (!ilDashboardAzureServiceID) {
      result = originalAzureServices;
    }
    // if single `ilDashboardAzureServiceID` continue, otherwise split it into array of ilDashboardAzureServiceIDs
    ilDashboardAzureServiceID = isMultipleCompanyAzureServiceID
      ? ilDashboardAzureServiceID
        .split(',')
        .map((x: string) => x.trim())
        .join(';')
      : ilDashboardAzureServiceID;

    if (!contactHasAzureServices) {
      result = ilDashboardAzureServiceID;
    }

    if (contactHasAzureServices && ilKpiValue) {
      result = `${originalAzureServices};${ilDashboardAzureServiceID}`;
    } else if (contactHasAzureServices && !ilKpiValue) {
      let contactAzureServicesIds = originalAzureServices.split(';');
      const dashboardAzureServicesIds = ilDashboardAzureServiceID.split(';');

      // remove `dashboardAzureServicesIds` from Contact `azureServices`
      contactAzureServicesIds = contactAzureServicesIds.filter((x) => !dashboardAzureServicesIds.includes(x));
      result = contactAzureServicesIds.join(';');
    }

    return result;
  }
}
